import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/HomePage';
import Footer from './components/Footer';
import JobsPage from './pages/JobsPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import JobView from './components/JobsPage/JobView';
import AdminPage from './pages/AdminPage';

function MainApp() {
  return (
    <main>
      <section id="home"><Home /></section>
    </main>
  );
}

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <Header currentPath={location.pathname} />
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/jobs/:jobId" element={<JobView />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
